import { render } from "./ShouHuXing.vue?vue&type=template&id=403e8946"
import script from "./ShouHuXing.vue?vue&type=script&lang=js"
export * from "./ShouHuXing.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PRG\\gitEE\\wwj\\web\\htweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__